import React from 'react';

import { Box, Stack, Skeleton, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const CustomSkeleton = () => (
    <Typography variant="h3">
        <Skeleton></Skeleton>
    </Typography>
);

const Placeholder = () => (
    <Box>
        <Stack>
            <CustomSkeleton />
        </Stack>
        <Stack>
            <CustomSkeleton />
        </Stack>
        <Stack>
            <CustomSkeleton />
        </Stack>
    </Box>
);

const PlaceholderHistory = ({ children, ready }) => {
    return <>{ready ? <Placeholder /> : children}</>;
};

PlaceholderHistory.propTypes = {
    children: PropTypes.node,
    ready: PropTypes.bool,
};

export default PlaceholderHistory;
